<template>
  <div>
    <div id="rg" v-if="baustelle.length" ref="content">
      <img class="logo" src="../assets/logo_hammer.jpg" alt />

      <div class="adressat">
        <input type="text" placeholder="" />
        <p>
          <input type="text" size="80" v-model="baustelle[0].empfaenger" />
        </p>
        <p>
          <input type="text" size="80" v-model="baustelle[0].rechnungsadresse" />
        </p>
        <p>
          <input type="text" size="80" v-model="baustelle[0].plz" />
        </p>
      </div>

      <div class="dt">
        <p>
          Wels,
          <input type="text" size="10" v-model="heute" />
        </p>
      </div>

      <div class="title">
        <h3>
          <input type="text" class="b" id="teilr" v-model="teilrechungsNr" />
        </h3>
      </div>

      <div class="leistung">
        <table>
          <tbody>
            <tr>
              <th>Bauvorhaben</th>
              <td>
                <input type="text" class="fw" v-model="baustelle[0].bvh" />
              </td>
            </tr>
            <tr>
              <th>Baustellenadresse</th>
              <td>
                <input type="text" class="fw" size="75" v-model="baustelle[0].adresse" />
              </td>
            </tr>
            <tr>
              <th>Auftragsgegenstand</th>
              <td>
                <input type="text" class="fw" v-model="auftrGgst" />
              </td>
            </tr>
            <tr>
              <th>Rechnungsnummer</th>
              <td>
                <input type="text" v-model="TR.rgnr" />
              </td>
            </tr>
            <tr>
              <th>Leistungszeitraum</th>
              <td>
                <input class="fw" type="text" v-model="lstngsstnd"/>
              </td>
            </tr>
            <tr>
              <th>UID Nr.</th>
              <td>
                <input type="text" v-model="baustelle[0].uid" />
              </td>
            </tr>
            <tr>
              <th>Auftragsgrundlage</th>
              <td>
                Auftrag vom
                <input type="text" v-model="datumAuftr" />
              </td>
            </tr>
            <tr>
              <th>Auftragsnummer</th>
              <td>
                <input type="text" v-model="baustelle[0].auftragsnummer" />
              </td>
            </tr>
            <tr>
              <th>Auftrag gesamt</th>
              <td>
                €
                <input type="text" size="100" v-model="formatAuftragssumme" />
              </td>
            </tr>
          </tbody>
        </table>
        <textarea cols="30" rows="1" class="anm" v-model="anm"></textarea>

        <div v-if="baustelle[0].zahlungsplan.length > 1">
          <div>
            <h3>Bisher verrechnet</h3>
          </div>
          <table class="summeTRs">
            <tbody>
              <tr>
                <th>Teilrechnung</th>
                <th>Datum</th>
                <th>Nr.</th>
                <th>Netto €</th>
                <th>20% Mwst. €</th>
                <th style="border: none">Brutto €</th>
              </tr>
              <tr v-for="zptr in baustelle[0].zahlungsplan" :key="zptr.id">
                <th v-if="zptr.bezahlt || zptr.verrechnet">{{ zptr.TR }}. Teilrechnung</th>
                <td v-if="zptr.bezahlt || zptr.verrechnet">{{ zptr.datum | formatStrDate }}</td>
                <td v-if="zptr.bezahlt || zptr.verrechnet">{{ zptr.rgnr }}</td>
                <td
                  v-if="zptr.bezahlt || zptr.verrechnet"
                >{{ zptr.rechnungsbetrag.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                <td
                  v-if="zptr.bezahlt || zptr.verrechnet"
                >{{ (zptr.rechnungsbetrag * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                <td
                  v-if="zptr.bezahlt || zptr.verrechnet"
                >{{ (zptr.rechnungsbetrag * 0.2 + zptr.rechnungsbetrag).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="sumTRs">
            <tbody>
              <th>Summe Teilrechnungen</th>
              <td
                width="16.8%"
              >€ {{summeTRs.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                width="16.8%"
              >€ {{(summeTRs * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                width="16.8%"
              >€ {{(summeTRs * 0.2 + summeTRs).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tbody>
          </table>
        </div>

        <table id="summe" v-if="baustelle[0].zahlungsplan.length > 1">
          <tbody>
            <tr>
              <th></th>
              <th>Nettobetrag</th>
              <th>20% Mwst</th>
              <th>Summe</th>
            </tr>
            <tr>
              <td style="text-align: left">Gesamtrechnungssumme</td>
              <td>€ {{ (TR.rechnungsbetrag + summeTRs).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ ((TR.rechnungsbetrag + summeTRs) * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ ((TR.rechnungsbetrag + summeTRs) +  (TR.rechnungsbetrag  + summeTRs) * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>
            <tr>
              <td style="text-align: left">Abzügl. Teilrechnungen</td>
              <td>€ {{ summeTRs.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (summeTRs * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (summeTRs + summeTRs * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>

            <tr v-if="addons.count">
              <td style="text-align: left">{{addons.count}} {{addons.name}} à {{addons.price}}.-</td>
              <td>€ {{ (addons.count * addons.price).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (addons.count * addons.price * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (addons.count * addons.price * 1.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>

            <tr>
              <td style="text-align: left"><input type="text" v-model="teilrechnungsbetrag"></td>
              <td>€ {{formatTR}}</td>
              <td>€ {{ (TR.rechnungsbetrag * 0.2  + (addons.count * addons.price * 0.2)).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                class="b"
              >€ {{ (TR.rechnungsbetrag * 1.2  + (addons.count * addons.price * 1.2)).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>
          </tbody>
        </table>

        <table v-else style="border: 2px solid #000">
          <tbody>
            <tr v-if="addons.count">
              <td style="text-align: left">Auftragssumme</td>
              <td>€ {{ formatAuftragssumme }}</td>
              <td>€ {{ (baustelle[0].auftragssumme * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (baustelle[0].auftragssumme * 1.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>
            <tr v-if="addons.count">
              <td style="text-align: left">{{addons.count}} {{addons.name}} à € {{addons.price}}.-</td>
              <td>€ {{ (addons.count * addons.price).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (addons.count * addons.price * 0.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td>€ {{ (addons.count * addons.price * 1.2).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>
            <tr>
              <td style="text-align: left">Rechnungsbetrag</td>
              <td>€ {{formatTR}}</td>
              <td>€ {{ (TR.rechnungsbetrag * 0.2 + (addons.count * addons.price * 0.2)).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                class="b"
              >€ {{ (TR.rechnungsbetrag * 1.2 + (addons.count * addons.price * 1.2)).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="info">
        <p>Zahlungskonditionen: {{ baustelle[0].zkn }}</p>
      </div>

      <div class="qr-foot">
        <div class="foot">
          <p>Bitte überweisen Sie den Rechnungsbetrag auf das folgende Konto:</p>
          <p>IBAN: AT33 3406 8000 0003 1344 BIC: RZOOAT2L068</p>
          <p>UID Nr.: ATU 63492269 FN: 292294w</p>
          <p class="info">Vielen Dank für Ihren Auftrag.</p>
        </div>
        <div style="text-align: right"><img :src="qrCode()" class="qr"></div>
      </div>
      <img class="fusszeile" src="../assets/fz.jpg" alt />
    </div>

    <div class="add" v-if="baustelle[0] && baustelle[0].addons">
      <h2>Zusätzliche Rechnungspositionen verrechnen?</h2>
      <input type="checkbox" @click="addAddons" v-model="addonsAdded">
    </div>

    <button class="button" @click="pdf">PDF Erstellen</button>
  </div>
</template>

<script>
const fb = require("../fbConfig");
import moment from "moment";
var qr = require('qr-image');

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import docDef from "./doc"

export default {
  props: ["id", "tr"],
  data() {
    return {
      baustelle: [],
      heute: moment().format('DD.MM.YYYY'),
      jahr: new Date().getFullYear(),
      adr1: "Adresszeile 1",
      adr2: "Adresszeile 2",
      plz: "PLZ, Ort",
      teilrechung: ". Teilrechnung",
      trNr: this.tr,
      teilrechungsNr: this.tr + ". Teilrechnung",
      anm:
        "Anmerkungen",
      auftrGgst: "Planungs- und Baustellenkoordination gem. §§ 4+5 BauKG",
      teilrechnungsbetrag: "Rechnungsbetrag",
      lz: "",
      lstngsstnd: "",
      addons: {
        count: 0,
        name: null,
        price: 0
      },
      addonsAdded: false
    };
  },
  created() {
    fb.baustellen
      .doc(this.id)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          this.baustelle.push(doc.data())
          this.baustelle.push(doc.data());
          this.calculateLeistungsstand();
          this.initializeAddons();
        }
      })
      .catch(err => {
        console.log("Error getting document", err);
      });
  },
  methods: {
    calculateLeistungsstand() {
      const currentPlan = this.baustelle[0].zahlungsplan.find(el => el.TR == (Number.isInteger(el.TR) ? parseInt(this.tr) : "SR"));
      const currentDate = moment(currentPlan.datum).format("DD.MM.YYYY");
      const pastDate = this.tr > 1 
        ? moment(this.baustelle[0].zahlungsplan.find(el => el.TR == this.tr - 1).datum).format("DD.MM.YYYY")
        : moment(this.baustelle[0].beginn).format("DD.MM.YYYY");
      this.lstngsstnd = `${pastDate} - ${currentDate}`;
    },
    initializeAddons() {
      if (this.TR.TR === 'SR') {
        this.addons = this.baustelle[0].addons || { count: 0, name: null, price: 0 };
        this.addonsAdded = true;
      } else {
        this.addons = { count: 0, name: null, price: 0 };
      }
    },
    addAddons() {
      if (!this.addonsAdded) {
        this.addons = this.baustelle[0].addons ? this.baustelle[0].addons : {count: 0, name: null, price: 0}
        this.addonsAdded = true
      } else {
        this.addons = {count: 0, name: null, price: 0}
        this.addonsAdded = false
      }
    },
    qrCode() {
      let amount = (this.TR.rechnungsbetrag * 1.2) + (this.addons.count * this.addons.price * 1.2)
      const qr_png = qr.imageSync(`BCD\n001\n1\nSCT\nRZOOAT2L068\nHammer Gmbh\nAT333406800000031344\nEUR${amount}\nCHAR\n\n${this.TR.rgnr + " " + this.baustelle[0].bvh}`, 
      { type: 'png' });
      return 'data:image/png;base64,' + qr_png.toString('base64');
    },
    pdf() {
      const formatCurrency = (value) => value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const addTableRow = (table, row) => table.push(row);
      const calculateTax = (amount) => amount * 0.2;
      const calculateTotal = (amount) => amount + calculateTax(amount);

      pdfMake.fonts = {
        Roboto: this.robotoFont,
        Arial: this.devMode ? this.robotoFont : this.arialFont
      };

      let content = docDef.docDefinition.content;
      content[3].text = 'Wels, ' + this.heute;
      content[2].columns[0].text = `${this.baustelle[0].empfaenger}\n${this.baustelle[0].rechnungsadresse}\n${this.baustelle[0].plz}`;
      content[4].columns[0].text = this.teilrechungsNr;

      let datenTable = content[5].table.body;
      datenTable[0][1].text = this.baustelle[0].bvh;
      datenTable[1][1].text = this.baustelle[0].adresse;
      datenTable[2][1].text = this.auftrGgst;
      datenTable[3][1].text = this.TR.rgnr;
      datenTable[4][1].text = this.lstngsstnd;
      datenTable[5][1].text = this.baustelle[0].uid;
      datenTable[6][1].text = 'Auftrag vom ' + this.datumAuftr;
      datenTable[7][1].text = this.baustelle[0].auftragsnummer;
      datenTable[8][1].text = '€ ' + formatCurrency(this.formatAuftragssumme);

      content[6].text = this.anm;

      if (this.baustelle[0].zahlungsplan.length > 1) {
        this.baustelle[0].zahlungsplan.forEach(el => {
          if (el.bezahlt || el.verrechnet) {
            let d = moment(el.datum).format('DD.MM.YYYY');
            let mwst = calculateTax(el.rechnungsbetrag);
            let sum = calculateTotal(el.rechnungsbetrag);
            addTableRow(content[8].table.body, [
              el.TR + '. Teilrechnung',
              { text: d, style: 'right' },
              { text: el.rgnr, style: 'right' },
              { text: formatCurrency(el.rechnungsbetrag), style: 'right' },
              { text: formatCurrency(mwst), style: 'right' },
              { text: formatCurrency(sum), style: 'right' }
            ]);
          }
        });

        let mwst = calculateTax(this.summeTRs);
        let sum = calculateTotal(this.summeTRs);
        addTableRow(content[8].table.body, [
          { text: 'Summe Teilrechnungen', style: 'rb' }, '', '',
          { text: '€ ' + formatCurrency(this.summeTRs), style: 'right' },
          { text: '€ ' + formatCurrency(mwst), style: 'right' },
          { text: '€ ' + formatCurrency(sum), style: 'right' }
        ]);

        let ges = this.TR.rechnungsbetrag + this.summeTRs;
        let gesMwst = calculateTax(ges);
        let gesSum = calculateTotal(ges);

        addTableRow(content[9].table.body, [
          { text: 'Gesamtrechnungssumme' },
          { text: '€ ' + formatCurrency(ges), style: 'right' },
          { text: '€ ' + formatCurrency(gesMwst), style: 'right' },
          { text: '€ ' + formatCurrency(gesSum), style: 'right' }
        ]);

        addTableRow(content[9].table.body, [
          { text: 'Abzügl. Teilrechnungen' },
          { text: '€ ' + formatCurrency(this.summeTRs), style: 'right' },
          { text: '€ ' + formatCurrency(mwst), style: 'right' },
          { text: '€ ' + formatCurrency(sum), style: 'right' }
        ]);

        if (this.addons.count > 0) {
          addTableRow(content[9].table.body, [
            { text: `${this.addons.count} ${this.addons.name} à € ${this.addons.price}.-` },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price), style: 'right' },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price * 0.2), style: 'right' },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price * 1.2), style: 'right' }
          ]);
        }

        let rbMwst = calculateTax(this.TR.rechnungsbetrag);
        let rbSum = calculateTotal(this.TR.rechnungsbetrag);
        addTableRow(content[9].table.body, [
          { text: 'Rechnungsbetrag', style: 'rb' },
          { text: '€ ' + formatCurrency(this.TR.rechnungsbetrag + (this.addons.count * this.addons.price)), style: 'tableSum' },
          { text: '€ ' + formatCurrency(rbMwst + (this.addons.count * this.addons.price * 0.2)), style: 'tableSum' },
          { text: '€ ' + formatCurrency(rbSum + (this.addons.count * this.addons.price * 1.2)), style: 'tableSum' }
        ]);
      } else {
        content[7] = { 'text': "" };
        content[8] = { 'text': "" };
        let rbMwst = calculateTax(this.TR.rechnungsbetrag);
        let rbSum = calculateTotal(this.TR.rechnungsbetrag);

        if (this.addons.count > 0) {
          addTableRow(content[9].table.body, [
            { text: 'Auftragssumme' },
            { text: '€ ' + formatCurrency(this.formatAuftragssumme), style: 'right' },
            { text: '€ ' + formatCurrency(this.baustelle[0].auftragssumme * 0.2), style: 'right' },
            { text: '€ ' + formatCurrency(this.baustelle[0].auftragssumme * 1.2), style: 'right' }
          ]);

          addTableRow(content[9].table.body, [
            { text: `${this.addons.count} ${this.addons.name} à € ${this.addons.price}.-` },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price), style: 'right' },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price * 0.2), style: 'right' },
            { text: '€ ' + formatCurrency(this.addons.count * this.addons.price * 1.2), style: 'right' }
          ]);
        }

        addTableRow(content[9].table.body, [
          { text: 'Rechnungsbetrag', style: 'rb' },
          { text: '€ ' + formatCurrency(this.TR.rechnungsbetrag + (this.addons.count * this.addons.price)), style: 'tableSum' },
          { text: '€ ' + formatCurrency(rbMwst + (this.addons.count * this.addons.price * 0.2)), style: 'tableSum' },
          { text: '€ ' + formatCurrency(rbSum + (this.addons.count * this.addons.price * 1.2)), style: 'tableSum' }
        ]);
      }

      content[10].text = 'Zahlungskonditionen: ' + this.baustelle[0].zkn;
      content[11].columns[1].image = this.qrCode();

      const filename = `${this.TR.rgnr}-${this.baustelle[0].auftraggeber}.pdf`;
      pdfMake.createPdf(docDef.docDefinition).download(filename);
    }
  },
  computed: {
    TR: function() {
      return this.baustelle[0].zahlungsplan.find(x => x.TR == this.tr);
    },
    datumAuftr: function() {
      return moment(this.baustelle[0].auftragsdatum).format("DD.MM.YYYY");
    },
    datumTR: function() {
      return moment(this.TR.datum).format("DD.MM.YYYY");
    },
    formatAuftragssumme: function() {
      return this.baustelle[0].auftragssumme.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatTR: function() {
      return (this.TR.rechnungsbetrag + (this.addons.count * this.addons.price)).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    summeTRs: function() {
      let a = [];
      this.baustelle[0].zahlungsplan.forEach(el => {
        if (el.bezahlt || el.verrechnet ) {
          a.push(el.rechnungsbetrag);
        }
      });
      return a.reduce((a, b) => a + b, 0);
    },
    devMode() {
      return process.env.NODE_ENV === 'development'
    },
    robotoFont() {
      return {
        normal:'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    },
    arialFont() {
      return {
        normal:'https://elisabot.sophie.work/pdf-fonts/arial.ttf',
        bold: 'https://elisabot.sophie.work/pdf-fonts/arial-bold.ttf',
        italics: 'https://elisabot.sophie.work/pdf-fonts/arial-italic.ttf',
        bolditalics: 'https://elisabot.sophie.work/pdf-fonts/arial-bold-italic.ttf'
      }
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  }
};
</script>

<style scoped>
#rg {
  margin: 30px 0px;
  width: 730px;
  height: 1133px;
  color: black;
  padding: 30px 60px;
  font-family: 'Roboto', sans-serif;
  font-size: 12pt;
  position: relative;
  background: #fff;
}

h3 {
  margin: 0 0 10px 0;
  font-size: 1em;
}

.logo {
  margin-top: 70px;
  float: right;
  width:30%;
}

p {
  margin: 0;
}

input {
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 1em;
}

table input {
  width: 85%;
}

::placeholder {
  color: #000;
}

.adressat {
  margin-top: 170px;
  font-size: 0.9em;
}

.adressat input {
  text-align: left;
}

.dt {
  text-align: right;
}

.title {
  margin-top: 30px;
}

.title input {
  text-align: right;
}

table {
  width: 100%;
  margin-right: 20px;
  margin-bottom: 10px;
  border-collapse: collapse;
  font-size: 12pt;
  border: 1px solid #999;
}

td,
th {
  border-top: 1px solid #999;
  border-right: 1px solid #999;
  padding: 0.15rem 5px;
  font-size: 0.9em;
}

td:last-of-type {
  border-right: none;
}

.fw {
  width: 100%;
}

#summe {
  font-size: 12pt;
  border: none;
}

#summe td,
#summe th,
.sumTRs td {
  text-align: right;
}

#summe td {
  border: none;
}

#summe th {
  border: none;
  border-bottom: 1px solid #999;
}

#summe tr:last-of-type {
  border: 2px solid black;
}

.leistung th {
  text-align: left;
}

.info {
  font-size: 0.9em;
  margin-top: 10px;
}

.anm {
  font-family: 'Roboto', sans-serif;
}

.foot {
  font-size: 0.9em;
  margin-top: 10px;
}

.fusszeile {
  position: absolute;
  bottom: 20px;
  width: 95%;
  left: 20px;
}

.b {
  font-weight: bold;
}

#teilr {
  text-align: left;
}

.summeTRs {
  table-layout: fixed;
  margin-bottom: 0;
}

.summeTRs th {
  font-weight: normal;
}

.summeTRs th{
  border-right: 1px solid #999;
}

.summeTRs td {
  text-align: right;
}

.qr {
  width: 100px;
  height: 100px;
}

.qr-foot {
  display: flex;
  justify-content: space-between;
}

.add {
  margin: 30px 0;
}

.add h2 {
  display: inline;
}

.add input {
  display: inline;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  margin-left: 10px;
  vertical-align: bottom;
}

</style>